import { useMutation } from "@tanstack/react-query";
import { useToast } from "../../../Services/ToastContext";
import { GeneralResponse } from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { EndPoints } from "../../../Constants/endpoints";
import { Constants, Methods } from "../../../Constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../generalApi/ApiError";
import { useTranslation } from "react-i18next";

export interface ForgetPasswordRequest {
  Identification: string;
  CountryId: number;
}

export const useForgetPasswordRequest = () => {
  const navigate = useNavigate();
  const { showToast } = useToast(); 
  const { t } = useTranslation();
  const mutation = useMutation<
    GeneralResponse,
    ApiError,
    ForgetPasswordRequest
  >({
    mutationFn: (data: ForgetPasswordRequest): Promise<GeneralResponse> => {
      return Api<ForgetPasswordRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.ForgetPassword,
        body: data,
      });
    },
    onSuccess: (data) => {
      // Check if the response is successful
      if (data.Status) {
        // showToast(t("verification_code_sent_successfully"), "success");
      } else {
        // Handle the error response
        showToast(data.ErrorMessage || t("forget_password_failed"), "error");
      }
    },
    onError: (error) => {
      showToast(error.message || t("error_occurred"), "error");
      if (error.code === Constants.USER_BLOCKED) {
        navigate("/user-blocked");
      }
    },
  });

  return mutation;
};

export default useForgetPasswordRequest;
